/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/


import React from "react";
import "./Links.css";
import '../YTVideos/YTVideos.css';


function Biography() {
  return (
<div className="bio-container">
<div className="row">

<div className="col-3 col-s-3 menu">
  <ul>
 
  </ul>
</div>
<div className="col-6 col-s-9">
<div>

</div>
  <h1 id="bio-title">MasteredTrax</h1>
   <div className='social-icons-bio'>
            <a className='social-icon-link-2 facebook' target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/jaepmusica"><i className='fab fa-facebook-f' /></a>
            <a className='social-icon-link-2 instagram' target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/jaepmusica"><i className='fab fa-instagram' /></a>
            <a className='social-icon-link-2 youtube' target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/user/officialjaep"><i className='fab fa-youtube' /></a>
            <a className='social-icon-link-2 spotify' target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/artist/3NSh7BDsYShF4Tvi9tAtc9"><i className='fab fa-spotify' /></a>
            <a className='social-icon-link-2 apple' target="_blank" rel="noopener noreferrer" href="https://music.apple.com/us/artist/jae-p/65432254"><i className='fab fa-apple' /></a>
    </div>
  <div className="listen-to-buttons">
 
  <a className='button' target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/track/6Og7XMeW8to0acpJ916cg1?si=7c0127c89eac47b4"><i className='fab fa-spotify' /> iLogico Ft. Xochitl Pili</a>
  <a className='button' target="_blank" rel="noopener noreferrer" href="https://music.apple.com/us/album/il%C3%B3gico-feat-xochitl-pilli/1587401613?i=1587401615"><i className='fab fa-apple' /> iLogico Ft. Xochitl Pili</a>
  <a className='button' target="_blank" rel="noopener noreferrer" href="https://jaepclasicas.com"><i className='fas fa-shopping-cart' /> Tienda</a>
  </div>
  <iframe className="ytvideo" src="https://www.youtube.com/embed/kZPoH5kmOXI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

</div>
  
</div>
</div>
  );
}

export default Biography;


